import React, { useMemo } from 'react';
import { Text } from 'react-native';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useAppSelector } from 'store/hooks';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount } from 'utils';
import BlurAmountView from './BlurAmountView';
import { rem } from './values';
export const CurrencyAmountText = ({ value, size, showPlus, showMinus = true, scramblable = true, showFraction = true, }) => {
    const styleSet = useMemo(() => getStyleSet(size), [size]);
    const styles = useStyles(styleSet);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const content = useMemo(() => {
        const formattedAmount = formatAmount(Math.abs(value.amount), undefined, 2);
        const [amount, fraction] = formattedAmount.split('.');
        const currencySymbol = getSymbolFromCurrency(value.currency) || value.currency;
        const plus = showPlus && value.amount > 0 ? '+' : null;
        const minus = showMinus &&
            value.amount < 0 &&
            Number(Math.abs(value.amount).toFixed(2)) !== 0
            ? '-'
            : null;
        const sign = plus || minus;
        const showDecimals = showFraction || !!Number(fraction);
        return (<Text style={styles.outer} numberOfLines={1}>
        {sign !== null && (<Text style={[styles.currency, styles.currencyLast]}>{sign}</Text>)}
        <Text style={styles.currency}>
          {currencySymbol.slice(0, -1)}
          <Text style={styles.currencyLast}>{currencySymbol.slice(-1)}</Text>
        </Text>
        <Text style={styles.amount}>{amount}</Text>
        {!!showDecimals && <Text style={styles.fraction}>.{fraction}</Text>}
      </Text>);
    }, [showFraction, showMinus, showPlus, styles, value]);
    return (<BlurAmountView enabled={!!(scramblable && scrambled)} containerStyle={scramblable && scrambled ? styles.scrambled : null}>
      {content}
    </BlurAmountView>);
};
const scrambled = {
    XL: { height: rem(34), marginVertical: rem(16) },
    L: { height: rem(25), marginVertical: rem(12) },
    M: { height: rem(18), marginVertical: rem(6) },
};
const currency = {
    XL: { fontSize: rem(40), letterSpacing: rem(4) },
    L: { fontSize: rem(30), letterSpacing: rem(4) },
    M: { fontSize: rem(22), letterSpacing: rem(2) },
};
const amount = {
    XL: { fontSize: rem(48) },
    L: { fontSize: rem(36) },
    M: { fontSize: rem(26) },
};
const fraction = {
    XL: { fontSize: rem(32) },
    L: { fontSize: rem(24) },
    M: { fontSize: rem(17) },
};
const getStyleSet = (size) => createStyleSheets((colors) => ({
    scrambled: scrambled[size],
    outer: {
        fontFamily: 'Nunito-ExtraBold',
        color: colors.text.primary,
    },
    currency: {
        fontSize: currency[size].fontSize,
    },
    currencyLast: {
        letterSpacing: currency[size].letterSpacing,
    },
    amount: {
        fontSize: amount[size].fontSize,
    },
    fraction: {
        fontSize: fraction[size].fontSize,
    },
}));
